import React from 'react';
import './index.css';

export function AcceptButtons(props) {
  return (
    <button data-testid={props.datatestid ? props.datatestid : "save-button"} style={{ background: props.background,color:props.color }} disabled={props.disabled} className={props.className ? props.className:'AcceptButtonsBtn'} onClick={props.onClick}>{props.children}</button>
  )
}

export default AcceptButtons;